export const confidenceBg = (c) => c >= 0.8 ? 'success' : c >= 0.6 ? 'warning' : 'secondary'
